export default "__VITE_ASSET__9396ca8d__"